var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getRedirectUrl)?_c('div',{staticClass:"test__wrapper"},[_vm._v("\n    Для прохождения "+_vm._s(_vm.getTypeTitle[1])+" перейдите по\n    "),_c('a',{attrs:{"href":_vm.getRedirectUrl,"target":"__blank"}},[_vm._v("cсылке")])]):_c('div',{staticClass:"test__wrapper"},[_vm._v("\n    "+_vm._s(_vm.getTypeTitle[0])+" не найден\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }